import { TbAspectRatio } from 'react-icons/tb';
import { MdOutlineCalendarMonth } from 'react-icons/md';
import { BsReverseListColumnsReverse } from 'react-icons/bs';
import { RenderTiles } from '../../components/common';
import ChildHeader from '../../components/ui/ChildHeader';
import { apiConstant, tilesConstant } from './constant';

const tiles = [
  {
    sNo: 1,
    link: '/common/spcPlanPlanList',
    isLink: true,
    icon: <MdOutlineCalendarMonth size="5rem" color="#343a40" />,
    p: 'SPC',
    span: 'PLAN',
    isIcon: true,
  },

  {
    sNo: 2,
    link: '/common/spcPlanChecklistList',
    isLink: true,
    icon: <BsReverseListColumnsReverse size="5rem" color="#087f5b" />,
    p: 'SPC',
    span: 'STATUS',
    isIcon: true,
  },
  // {
  //   sNo: 2,
  //   link: '/common/MasterListofspcPlan',
  //   isLink: true,
  //   icon: <TbAspectRatio size="5rem" color="#343a40" />,
  //   p: 'Master list of',
  //   span: 'SPC',
  //   isIcon: true,
  // },
];

const Tiles = () => {
  return (
    <>
      <ChildHeader text={tilesConstant.childHeaderText} />
      <RenderTiles
        tilesObj={tiles}
        height="100vh"
        justify="start"
        columns="0"
      />
    </>
  );
};

export default Tiles;
